// extracted by mini-css-extract-plugin
export default {"alertBoxMessage":"styles-module__alertBoxMessage--tj60z","alertBoxContainer":"styles-module__alertBoxContainer--XeF6y"};